import { leadForwardingProjectBaseSchema } from "./leadForwardingProjectBaseSchema";
import { projectStatusSchema } from "./projectStatusSchema";
import { reviewStatusSchema } from "./reviewStatusSchema";
import { z } from "zod";

export const leadForwardingProjectSchema = z
  .lazy(() => leadForwardingProjectBaseSchema)
  .and(
    z.object({
      projectId: z.coerce.string(),
      realizedRevenue: z.coerce.number(),
      projectStatus: z.lazy(() => projectStatusSchema),
      reviewStatus: z.lazy(() => reviewStatusSchema),
    }),
  );

export type LeadForwardingProject = z.infer<typeof leadForwardingProjectSchema>;
